import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { NavLink, NavLinkMode } from '@rd/types';

@Component({
  selector: 'rd-core-header-dropdown-link',
  templateUrl: './header-dropdown-link.component.html',
  styleUrls: ['./header-dropdown-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderDropdownLinkComponent {
  @HostBinding('class.rd-core-header-dropdown-link') componentClass = true;
  @Input() navLink: NavLink;
  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  navLinkMode(): NavLinkMode {
    if (!this.redirectURLExists()) {
      return 'callback';
    }

    if (this.isInternalURL()) {
      return 'internalURL';
    } else {
      return 'externalURL';
    }
  }

  navLinkClicked(): void {
    this.clickEvent.emit();
  }

  private redirectURLExists(): boolean {
    return this.navLink ? this.navLink.route !== null : false;
  }

  private isInternalURL(): boolean {
    if (!this.navLink) {
      return false;
    }
    const { route } = this.navLink;
    return !(
      route.toString().startsWith('http://') ||
      route.toString().startsWith('https://')
    );
  }
}
